// This is example of menu item without group for horizontal layout. There will be no children.

// third-party
import { FormattedMessage } from "react-intl";

// assets
import Agenda from "../assets/icons/calendar-03.svg";

const icons = {
  agenda: () => <img src={Agenda} alt="agenda icon" />,
};

// ==============================|| MENU ITEMS - SAMPLE PAGE ||============================== //

const agenda = {
  id: "agenda",
  title: <FormattedMessage id="agenda" />,
  type: "group",
  url: "/agenda",
  icon: icons.agenda,
};

export default agenda;
